<div class="dashboard-container">
  <div class="container-fluid p-4">
    <!-- Header -->
    <div class="dashboard-header d-flex flex-wrap justify-content-between align-items-center m-4">
      <div class="dashboard-title-container mb-3 mb-md-0">
        <h3>Dashboard</h3>
      </div>
      <div class="d-flex align-items-center gap-3">
        <button class="upload-btn rounded-pill text-white" aria-label="Upload">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true">
            <path d="M10 2.5V13.75M10 2.5L6.25 6.25M10 2.5L13.75 6.25" stroke="white" stroke-width="1.5"
              stroke-linecap="round" stroke-linejoin="round" />
            <path d="M2.5 13.75V16.25C2.5 17.0784 3.17157 17.75 4 17.75H16C16.8284 17.75 17.5 17.0784 17.5 16.25V13.75"
              stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      </div>
    </div>

    <!-- Summary Cards -->
    <div class="row g-3 mb-4">
      <div class="col-md-2 col-sm-4 col-6" *ngFor="let card of summaryCards; trackBy: trackByCardIndex">
        <div class="card summary-card h-100">
          <div class="card-body">
            <div class="icon-wrapper mb-2" [style.background-color]="card.iconColor + '15'">
              <ng-container [ngSwitch]="card.icon">
                <!-- Total Tenders -->
                <svg *ngSwitchCase="'bi-file-earmark-text'" width="20" height="20" viewBox="0 0 20 20" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12.5007 1.66699H5.00065C4.55862 1.66699 4.1347 1.84259 3.82214 2.15515C3.50958 2.46771 3.33398 2.89163 3.33398 3.33366V16.667C3.33398 17.109 3.50958 17.5329 3.82214 17.8455C4.1347 18.1581 4.55862 18.3337 5.00065 18.3337H15.0007C15.4427 18.3337 15.8666 18.1581 16.1792 17.8455C16.4917 17.5329 16.6673 17.109 16.6673 16.667V5.83366L12.5007 1.66699Z"
                    stroke="#E31A51" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M11.666 1.66699V5.00033C11.666 5.44235 11.8416 5.86628 12.1542 6.17884C12.4667 6.4914 12.8907 6.66699 13.3327 6.66699H16.666"
                    stroke="#E31A51" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M8.33268 7.5H6.66602" stroke="#E31A51" stroke-width="1.66667" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M13.3327 10.833H6.66602" stroke="#E31A51" stroke-width="1.66667" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M13.3327 14.167H6.66602" stroke="#E31A51" stroke-width="1.66667" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
                <!-- Pending Evaluations -->
                <svg *ngSwitchCase="'bi-graph-up-arrow'" width="20" height="20" viewBox="0 0 20 20" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.334 5.83301H18.334V10.833" stroke="#F36E23" stroke-width="1.66667" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M18.3327 5.83301L11.2493 12.9163L7.08268 8.74967L1.66602 14.1663" stroke="#F36E23"
                    stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <!-- Active Meetings -->
                <svg *ngSwitchCase="'bi-people'" width="20" height="20" viewBox="0 0 20 20" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M13.3327 17.5V15.8333C13.3327 14.9493 12.9815 14.1014 12.3564 13.4763C11.7313 12.8512 10.8834 12.5 9.99935 12.5H4.99935C4.11529 12.5 3.26745 12.8512 2.64233 13.4763C2.01721 14.1014 1.66602 14.9493 1.66602 15.8333V17.5"
                    stroke="#952873" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M13.334 2.60645C14.0488 2.79175 14.6818 3.20917 15.1337 3.79316C15.5856 4.37716 15.8308 5.09469 15.8308 5.83311C15.8308 6.57154 15.5856 7.28906 15.1337 7.87306C14.6818 8.45706 14.0488 8.87447 13.334 9.05978"
                    stroke="#952873" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M18.334 17.5001V15.8334C18.3334 15.0948 18.0876 14.3774 17.6351 13.7937C17.1826 13.2099 16.5491 12.793 15.834 12.6084"
                    stroke="#952873" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M7.49935 9.16667C9.3403 9.16667 10.8327 7.67428 10.8327 5.83333C10.8327 3.99238 9.3403 2.5 7.49935 2.5C5.6584 2.5 4.16602 3.99238 4.16602 5.83333C4.16602 7.67428 5.6584 9.16667 7.49935 9.16667Z"
                    stroke="#952873" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <!-- Open Actions -->
                <svg *ngSwitchCase="'bi-clipboard-check'" width="20" height="20" viewBox="0 0 20 20" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M17.5 8.88V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H14.4533"
                    stroke="#00A63E" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M7.5 9.16634L10 11.6663L18.3333 3.33301" stroke="#00A63E" stroke-width="1.66667"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <!-- Total Minutes -->
                <svg *ngSwitchCase="'bi-calendar'" width="20" height="20" viewBox="0 0 20 20" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12.4993 1.66699H7.49935C7.03911 1.66699 6.66602 2.04009 6.66602 2.50033V4.16699C6.66602 4.62723 7.03911 5.00033 7.49935 5.00033H12.4993C12.9596 5.00033 13.3327 4.62723 13.3327 4.16699V2.50033C13.3327 2.04009 12.9596 1.66699 12.4993 1.66699Z"
                    stroke="#652D86" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M12.4993 1.66699H7.49935C7.03911 1.66699 6.66602 2.04009 6.66602 2.50033V4.16699C6.66602 4.62723 7.03911 5.00033 7.49935 5.00033H12.4993C12.9596 5.00033 13.3327 4.62723 13.3327 4.16699V2.50033C13.3327 2.04009 12.9596 1.66699 12.4993 1.66699Z"
                    stroke="black" stroke-opacity="0.2" stroke-width="1.66667" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path
                    d="M13.334 3.33301H15.0007C15.4427 3.33301 15.8666 3.5086 16.1792 3.82116C16.4917 4.13372 16.6673 4.55765 16.6673 4.99967V16.6663C16.6673 17.1084 16.4917 17.5323 16.1792 17.8449C15.8666 18.1574 15.4427 18.333 15.0007 18.333H5.00065C4.55862 18.333 4.1347 18.1574 3.82214 17.8449C3.50958 17.5323 3.33398 17.1084 3.33398 16.6663V4.99967C3.33398 4.55765 3.50958 4.13372 3.82214 3.82116C4.1347 3.5086 4.55862 3.33301 5.00065 3.33301H6.66732"
                    stroke="#652D86" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M13.334 3.33301H15.0007C15.4427 3.33301 15.8666 3.5086 16.1792 3.82116C16.4917 4.13372 16.6673 4.55765 16.6673 4.99967V16.6663C16.6673 17.1084 16.4917 17.5323 16.1792 17.8449C15.8666 18.1574 15.4427 18.333 15.0007 18.333H5.00065C4.55862 18.333 4.1347 18.1574 3.82214 17.8449C3.50958 17.5323 3.33398 17.1084 3.33398 16.6663V4.99967C3.33398 4.55765 3.50958 4.13372 3.82214 3.82116C4.1347 3.5086 4.55862 3.33301 5.00065 3.33301H6.66732"
                    stroke="black" stroke-opacity="0.2" stroke-width="1.66667" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M10 9.16699H13.3333" stroke="#652D86" stroke-width="1.66667" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M10 9.16699H13.3333" stroke="black" stroke-opacity="0.2" stroke-width="1.66667"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M10 13.333H13.3333" stroke="#652D86" stroke-width="1.66667" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M10 13.333H13.3333" stroke="black" stroke-opacity="0.2" stroke-width="1.66667"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M6.66602 9.16699H6.67435" stroke="#652D86" stroke-width="1.66667" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M6.66602 9.16699H6.67435" stroke="black" stroke-opacity="0.2" stroke-width="1.66667"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M6.66602 13.333H6.67435" stroke="#652D86" stroke-width="1.66667" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M6.66602 13.333H6.67435" stroke="black" stroke-opacity="0.2" stroke-width="1.66667"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <!-- Pending Review -->
                <svg *ngSwitchCase="'bi-circle-fill'" width="20" height="20" viewBox="0 0 20 20" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.99935 18.3337C14.6017 18.3337 18.3327 14.6027 18.3327 10.0003C18.3327 5.39795 14.6017 1.66699 9.99935 1.66699C5.39698 1.66699 1.66602 5.39795 1.66602 10.0003C1.66602 14.6027 5.39698 18.3337 9.99935 18.3337Z"
                    stroke="#FDB814" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M10 6.66699V10.0003" stroke="#FDB814" stroke-width="1.66667" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M10 13.333H10.0083" stroke="#FDB814" stroke-width="1.66667" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </ng-container>
            </div>
            <h3 class="card-value mb-1">{{ card.value }}</h3>
            <p class="card-title text-muted mb-0">{{ card.title }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Charts Row 1: Pie Charts -->
    <div class="row g-4 mb-4">
      <!-- Tender Status Distribution -->
      <div class="col-md-6">
        <fieldset class="content-fieldset h-100">
          <legend class="section-legend d-flex justify-content-between align-items-center w-100 mb-4">
            <span>Tender Status Distribution</span>
            <a href="javascript:void(0)" class="view-all">View All</a>
          </legend>
          <div class="chart-container pie-chart-container">
            <p-chart type="pie" [data]="tenderStatusChartData" [options]="pieChartOptions"
              [style.height.px]="getChartHeight()"></p-chart>
          </div>
        </fieldset>
      </div>

      <!-- Evaluation Progress -->
      <div class="col-md-6">
        <fieldset class="content-fieldset h-100">
          <legend class="section-legend d-flex justify-content-between align-items-center w-100 mb-4">
            <span>Evaluation Progress</span>
            <a href="javascript:void(0)" class="view-all">View All</a>
          </legend>
          <div class="chart-container pie-chart-container">
            <p-chart type="pie" [data]="evaluationProgressChartData" [options]="pieChartOptions"
              [style.height.px]="getChartHeight()"></p-chart>
          </div>
        </fieldset>
      </div>
    </div>

    <!-- Charts Row 2: Line Chart -->
    <div class="row mb-4">
      <div class="col-12">
        <fieldset class="content-fieldset">
          <legend class="section-legend mb-4">Monthly Tenders & Bids Trend</legend>
          <div class="chart-container line-chart-container">
            <p-chart type="line" [data]="monthlyTrendChartData" [options]="lineChartOptions" height="300px"></p-chart>
          </div>
        </fieldset>
      </div>
    </div>

    <!-- Charts Row 3: Bar Charts -->
    <div class="row g-4 mb-4">
      <!-- Department-wise Tenders -->
      <div class="col-md-6">
        <fieldset class="content-fieldset h-100">
          <legend class="section-legend mb-4">Department-wise Tenders</legend>
          <div class="chart-container">
            <p-chart type="bar" [data]="departmentTendersChartData" [options]="departmentBarChartOptions"
              height="300px"></p-chart>
          </div>
        </fieldset>
      </div>

      <!-- Budget Allocation vs Spent -->
      <div class="col-md-6">
        <fieldset class="content-fieldset h-100">
          <legend class="section-legend mb-4">Budget Allocation vs Spent (QAR)</legend>
          <div class="chart-container">
            <p-chart type="bar" [data]="budgetChartData" [options]="budgetBarChartOptions" height="300px"></p-chart>
          </div>
        </fieldset>
      </div>
    </div>

    <!-- Pending Votes Table -->
    <div class="row mb-4">
      <div class="col-12">
        <fieldset class="content-fieldset">
          <legend class="section-legend d-flex justify-content-between align-items-center w-100 mb-4">
            <span>Pending Votes - Action Required</span>
            <a href="javascript:void(0)" class="view-all">View All</a>
          </legend>
          <app-data-table [data]="pendingVotes" [columns]="tableColumns" [paginator]="true" [rows]="10"
            (onActionClick)="onTableActionClick($event)" (onLinkClick)="onTableLinkClick($event)">
          </app-data-table>
        </fieldset>
      </div>
    </div>

  </div>
</div>